<template>
  <div class="t animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <div class=" title">预约处理</div>
    <div class="line"></div>
    <el-empty description="没有预约" v-if="currentitems.length == 0"></el-empty>
    <div class="father">
      <div class="box" v-for="item in currentitems" :key="item.txt">
        <div style="display: flex;margin-top: .125rem;margin-left: .1042rem;">
          <div class="name">家长称呼：{{ item.parentName }}</div>
          <div class="area">{{ location[item.studyArea] }}</div>
        </div>
        <div class="smallline"></div>
        <div v-if="item.contractStatus == 5" style="display: flex;" class="agree">
          <img src="../../assets/二维码.png" style="width: .5781rem;height: .5781rem;margin: .1563rem .1094rem 0 .1563rem;"
            alt="">
          <div style="width: 1.0417rem;height: .5208rem; margin-top: .2083rem;">
            <span>你已接受预约</span>
            <span>请联系学管老师沟通后续事宜</span>
            <span style="margin-top: .1302rem;">学管老师热线：12345678901</span>
          </div>
        </div>
        <div v-else-if="item.contractStatus == 2">
          <div style="width: 1.0417rem;height: .5208rem; margin-top: .2083rem;">
            <span>家长已接受预约</span>
            <span>请联系学管老师沟通后续事宜</span>
            <span style="margin-top: .1302rem;">学管老师热线：12345678901</span>
          </div>
        </div>
        <div v-else>
          <div class="student">学生情况</div>
          <div class="demand">{{ item.studentLearningSituation }}</div>
          <div v-if="item.contractStatus == 1">
            <button @click="refuse(item.cid)">拒绝</button>
            <button style="margin-left: .1458rem;" @click="accept(item.cid)">接受</button>
          </div>
          <div v-else-if="item.contractStatus == 0">
            <div class="reject" style="color:rgb(1, 162, 153) ;">已申请</div>
          </div>
          <div v-else-if="item.contractStatus == 4 || item.contractStatus == 3">
            <div class="reject">已拒绝预约</div>
          </div>
        </div>

      </div>

    </div>
    <div class="pagination" v-if="currentitems.length !== 0">
      <!-- <div class="first" @click="pageindex = 1">首页</div> -->
      <el-pagination layout="prev, pager, next" :total="parseInt(totalitems.length)" :page-size="4"
        :current-page="parseInt(pageindex)" :pager-count="7" @current-change="change" :key="pageindex">
      </el-pagination>
      <!-- <div class=" first" @click="pageindex = totalpages">尾页
      </div> -->
      <div class="txt">前往</div>
      <input type="text" v-model.lazy="pageindex">
      <div class="txt2">页</div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalitems: [],
      pageindex: 1,
      Authorization: '',
      currentitems: [],
      location: ['锦江区', '金牛区', '武侯区', '青羊区', '成华区', '高新区', '天府新区', '新都区', '郫都区', '双流区', '龙泉驿区', '温江区', '其他', '都江堰', '彭州', '邛崃', '崇州', '简阳', '金堂', '大邑', '蒲江', '新津', '青白江'],
    };
  },
  computed: {
    totalpages() {
      return Math.ceil(parseInt(this.totalitems.length) / 4)
    }

  },
  methods: {
    change(index) {
      this.pageindex = index
      this.currentitems = this.totalitems.slice((index - 1) * 4, index * 4)
    },
    refuse(cid) {
      console.log(cid);
      this.$http.put('/Api/Teacher/Contract/' + cid + '/Apply', {}, {
        headers: {
          'Authorization': this.Authorization
        }
      }).then(res => {
        console.log(res);
      })
    },
    accept(cid) {
      console.log(cid);
      this.$http.put('/Api/Teacher/Contract/' + cid + 'Refuse', {}, {
        headers: {
          'Authorization': this.Authorization
        }
      }).then(res => {
        console.log(res);
      })
    }
  },
  watch: {
    pageindex(n, o) {
      if (n !== o) {
        if (isNaN(parseInt(n))) {
          this.$message({
            message: '请输入数字',
            type: 'warning'
          });
          this.pageindex = o
        }
        if (n > Math.ceil(parseInt(this.totalitems.length) / 4) || n < 1) {
          this.$message({
            message: '您输入的范围不对哦~~',
            type: 'warning'
          });
          this.pageindex = o
        }
        this.currentitems = this.totalitems.slice((n - 1) * 4, n * 4)
      }



    }
  },
  created() {
    this.Authorization = localStorage.getItem('Authorization');
    this.$http.get('/Api/Teacher/Applies',
      {
        headers: {
          'Authorization': this.Authorization
        },
        params: {
          pageSize: 4,
          pageNumber: 1
        }
      }).then((res) => {

        // console.log(res.data.data.records);
        res.data.data.records.forEach(element => {
          this.$http.get('/Api/Teacher/Apply/' + element.cid, {
            headers: {
              'Authorization': this.Authorization
            }
          }).then(res => {
            // console.log(res.data.data);
            let data = res.data.data
            data.contractStatus = element.contractStatus
            data.cid = element.cid
            this.currentitems.push(data)
          })
        });
        console.log(this.currentitems);

      })
  }
};
</script>
<style scoped>
.title {
  /* 修改手机号 */
  height: 38px;
  color: rgb(0, 0, 0);
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 36px;
  font-weight: 400;
  line-height: 38px;
  letter-spacing: 0px;
  text-align: left;

}

.line {
  /* Line */
  width: 800px;
  height: 2px;
  background: rgb(220, 223, 230);
  margin-top: 16px;
}

.father {
  display: flex;
  flex-wrap: wrap;
  width: 848px;
  justify-content: space-between;
}

.box {
  /* 矩形 35 */
  display: inline-block;
  width: 404px;
  height: 248px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(220, 223, 230);
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.2);
  border-radius:
    10px;
  margin-top: 24px;
}

.box .name {
  /* 家长称呼：黄女士 */
  height: 24px;
  color: rgb(48, 49, 51);
  font-family: PingFangSC-Regular, sans-serif;
  ;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
}

.box .area {
  /* tag/default/default/light/off (style) */
  height: 22px;
  width: 65px;
  background: rgb(207, 242, 240);
  border: 1px solid rgb(207, 242, 240);
  border-radius:
    2px;
  /* 高新西区 */
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;
  padding-top: 2px;
  margin-left: 8px;
}

.smallline {
  /* 直线 1 */
  width: 404px;
  height: 0;
  border: 1px solid rgb(220, 223, 230);
  margin-top: 16px;
}

.student {
  /* 学生情况 */
  width: 56px;
  height: 22px;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.009999999776482582px;
  text-align: left;
  margin-top: 13px;
  margin-left: 17px;
}

.agree span {
  display: block;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.009999999776482582px;
  text-align: left;
}

.demand {
  width: 366.13px;
  height: 92px;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(220, 223, 230);
  border-radius:
    4px;
  color: rgb(168, 171, 178);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.009999999776482582px;
  text-align: left;
  margin: 8px 0 0 12px;
  padding: 5px 12px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reject {
  /* 已拒绝预约 */
  height: 38px;
  color: rgb(245, 106, 106);
  font-family: 苹方;
  font-size: 24px;
  font-weight: 400;
  line-height: 38px;
  letter-spacing: 0px;
  text-align: center;
  margin-top: 5PX;
}

button {
  width: 71px;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 205px;
  margin-top: 8px;
}

.t /deep/ .el-pager .active {
  background: rgb(1, 162, 153);
  color: rgb(255, 255, 255);
}

.t /deep/ .el-pager .number {
  /* 页1 */
  width: 35px;
  height: 35px;
  border-radius: 4px;
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 5.5px;
  margin-right: 5.5px;
  background: rgb(240, 242, 245);
  color: rgb(96, 98, 102);
}

.t /deep/ .el-pager .active {
  background: rgb(1, 162, 153);
  color: rgb(255, 255, 255);
}

.t /deep/ .el-pagination button {
  /* 上一页 */
  height: 35px;
  background: rgb(245, 245, 245);
  border-radius: 4px;
  color: rgb(0, 0, 0);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  padding: 0 !important;

}

/* .t /deep/ .el-pagination button,
.t /deep/ .el-pagination li {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
} */

.t .first,
.t /deep/ .pagination input {
  /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */
  margin-top: 3px;
}

.t /deep/ .el-pagination .more {
  /* box-shadow: none !important; */
  /* color: rgb(1, 162, 153); */
  /* margin-top: 5px; */
  background: rgb(240, 242, 245);
  width: 32px;
  height: 35px;
  border-radius:
    2px;
  /* font-size: 30px; */
  padding-top: 3px;
}

.pagination {
  margin-top: 70px;
  display: flex;
  height: 100px;
  width: 850px;
  justify-content: center;
  gap: 11px
}

.pagination .first {
  width: 46px;
  height: 35px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  /* 首页 */
  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  cursor: pointer;
}

.pagination .txt {
  /* 共 5 页 前往 */
  width: 40px;
  height: 35px;
  color: rgb(96, 98, 102);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;
  transform: translateX(10px);
}

.pagination input {
  /* 选页 */
  width: 60px;
  height: 35px;
  background: rgb(255, 255, 255);
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  text-align: center;
}

.pagination .txt2 {
  /* 页 */
  width: 15px;
  height: 35px;
  color: rgb(96, 98, 102);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;

}
</style>



// WEBPACK FOOTER //
// src/components/pages/teacherchuli.vue